export const HOME_DASHBOARD_COMING_SOON_TEXT = {
    eyebrowPill: 'Navigator',
    eyebrowLabel: 'Dashboard',
    title: 'Dashboards are coming soon.',
    message: 'You can continue your work from the navigation menu.',
    betaLabel: 'Home dashboard · Coming soon',
} as const
